import { enhancedTmsApiService } from '#api/enhancements/enhancedTmsApiService'
import type { WeightCheckResponse } from '#api/tmsApiService'
import { type ResultUpdater, runCheck } from '#app/store/middlewares/configurationRequests/checks/runCheck'
import type { TruckConfiguration } from '#store/slices/configurationSlice'
import type { CheckResult, CheckTaskId } from '#types/ConfigurationCheck'
import type { AppListenerApi } from '../../configurationRequestMiddleware'

export const weightCheckId = 'checkWeight' as CheckTaskId

export function isWeightResult(result: CheckResult): result is CheckResult<WeightCheckResponse> {
  return result.id === weightCheckId
}

export function runWeightCheck(api: AppListenerApi, configuration: TruckConfiguration, updater: ResultUpdater) {
  if (!configuration.uuid) {
    return
  }
  const promise = api.dispatch(
    enhancedTmsApiService.endpoints.getApiConfigurationByUuidCheckWeight.initiate(
      { uuid: configuration.uuid },
      {
        forceRefetch: true,
      },
    ),
  )

  return runCheck(
    promise,
    {
      id: weightCheckId,
    },
    updater,
  )
}
